








import {Component, Vue, Watch} from 'vue-property-decorator';
import BookingCalendarView from '@/components/Views/Dashboard/Booking/BookingCalendarView.vue';
import PagedTable from '@/components/Views/Dashboard/PagedTable.vue';
import {DateTime} from 'luxon';
import bookingDefault from '@/instance-defaults/bookingDefault';
import BookingOverview from '@/components/Views/Dashboard/Booking/BookingOverview.vue';
import {nil} from '@/common';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import SingleAndMultiDashboardPage from '@/components/Views/Dashboard/SingleAndMultiDashboardPage.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import BookingListItem from '@/components/Views/Dashboard/Booking/BookingListItem.vue';
import AdminBookingCard from '@/components/Views/Dashboard/Booking/AdminBookingCard.vue';
import BookingCard from '@/components/Views/Dashboard/Booking/BookingCard.vue';
import {getZonedBookingDate} from '@/utils';


@Component({
    components: {
        BookingCard,
        AdminBookingCard,
        BookingListItem,
        BookingOverview,
        PagedTable,
        BookingCalendarView,
    },
})
export default class Bookings extends Mixins(UserRoleMixin, SingleAndMultiDashboardPage, GlobalAlertMixin) {
    private selectedBookings = null;
    public feathersModel = this.$FeathersVuex.Booking;
    public routeParameter = 'booking';

    private headers = [
        {
            text: 'Customer Email',
            align: 'left',
            sortable: false,
            value: 'purchaser',
            func: (item: any) => nil(item.purchaserModel) ? ' - ' : item.purchaserModel.email,
        },
        {
            text: 'Service Purchased',
            align: 'left',
            sortable: false,
            value: 'service',
            html(item: any) {
                const service = item.serviceModel;
                if (nil(service)) {
                    return '';
                }
                const tierName = nil(service.tierModel) ? '' : service.tierModel.name;
                const categoryName = nil(service.categoryModel) ? '' : service.categoryModel.name;

                return `<strong> ${tierName}</strong> ${item.categoryName}: ${service.name}`;
            },
        },
        {
            text: 'Date',
            align: 'left',
            sortable: false,
            value: 'service',
            html: (item: any) => `${getZonedBookingDate(item).toFormat('DDDD')} <br/> ${getZonedBookingDate(item).toFormat('hh:mm a')}`,
        },
        {
            text: 'Details',
            align: 'left',
            sortable: false,
            value: 'guests',
            html: (item: any) => `${item.guests} Guests <br/> ${item.duration} Hours`,
        },

    ];

    public onBookingUpdated(booking) {
        this.itemBeingViewed = booking;
        this.showAlert('Updated', 'success');
    }

    private onQuery() {
        return undefined;
    }
}
